import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const financialRecordsRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.financialRecords.route,
      lazy: () =>
        import(
          "@pages/panelPages/financialManagements/financialRecords/financialRecords"
        ),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.financialManagements.financialRecords",
            [],
            "index",
            "main",
          );
        return {};
      },
    },
    permissions: ["patient"],
  },
];
